<template>

  <div class="centerStats">

    <h1 class="u-m0">
      Јавне статистике
    </h1>

    <p class="intro-text">
      <span>
        Овде можете видети статистике везане за јавне конкурсе, пројекте и средства.
      </span>
                       <span class="mobileview"> <br/>За најбољи приказ на мобилним уређајима, окрените телефон у режим пејзажа (landscape)
              <img src="@/assets/Rotate-to-landscape.gif" alt="Rotate Device"/>
            </span>
    </p>
    <form action="">
      <fieldset class="fieldset">
        <legend class="fieldset-legend">Филтрирање по јединици и датуму</legend>
        <div class="grid">
          <div class="grid-cell u-full u-xmed-auto fieldset-item">
            <label for="township" class="fieldset-label">Изаберите јединицу</label>
            <VueSelect v-model="selectedTownship" label="name" :options="townships" :reduce="township => township.id">
              <template v-slot:no-options>
                Нема резултата за унету претрагу!
              </template>
            </VueSelect>
          </div>
          <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
            <label for="date-from" class="fieldset-label">Датум од</label>
            <VueDatePicker v-model="date.from" :format="'dd.MM.yyyy.'" :enable-time-picker="false" :auto-apply="true"
              locale="sr" placeholder="Од датума" input-class-name="input" />
          </div>

          <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
            <label for="date-to" class="fieldset-label">Датум до</label>
            <VueDatePicker v-model="date.to" :format="'dd.MM.yyyy.'" :enable-time-picker="false" :auto-apply="true"
              locale="sr" placeholder="До датума" input-class-name="input" />
          </div>

          <div class="grid-cell u-full u-xmed-auto fieldset-item fieldset-item--noLabel">
            <button @click.stop.prevent="submit" class="button button--fieldset">Примени</button>
          </div>
        </div>
      </fieldset>
    </form>
    <PublicStatistics ref="publicStatisticsRef" />

  </div>
</template>
<script src="./Statistics.js"></script>

<style scoped>
.two-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  padding: 20px;
}

.centerStats {
  padding-top: 50px;
  text-align: center;
  margin: 0 auto;
  /* Centriranje (opciono) */
}

.chart-block {
  padding-top: 15px;
}

/* 📱 Collapse to one column on smaller screens */
@media (max-width: 768px) {
  .two-columns {
    grid-template-columns: 1fr;
  }
}

.column {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.chart-wrapper {
  max-width: 100%;
  width: 100%;
  height: 300px;
  position: relative;
  /* Important for Chart.js */
}

canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
